import { Fetcher } from '@pp/core/src/api/Fetcher';

import type { LastGameDataType } from './types';

export interface FetchLastGameDataParams {
  'table-id': string;
  url: string;
  JWTTOKEN: string;
  force: boolean;
  pageNum: number;
  pageSize: number;
  'game-id'?: string;
}

export const fetchLastGameData = ({
  'table-id': tableId,
  url,
  JWTTOKEN,
  pageNum,
  pageSize,
  force,
  'game-id': gameId,
}: FetchLastGameDataParams): Promise<LastGameDataType> => {
  return Fetcher.fetch<LastGameDataType>(url, {
    params: {
      'table-id': tableId,
      JWTTOKEN,
      pageNum,
      pageSize,
      'game-id': gameId!,
    },
    force,
  });
};
